{
  "slug": "do-testing-conditions-affect-iq-scores",
  "title": "Do Testing Conditions Affect IQ Scores?",
  "description": "Learn how sleep, noise, interruptions, anxiety, illness, device problems, and administration can influence test performance.",
  "summary": "Testing conditions can add construct-irrelevant difficulty or distraction. Standardization and contextual interpretation help separate the intended abilities from avoidable interference.",
  "category": "IQ questions answered",
  "sections": [
    {
      "heading": "Conditions that can matter",
      "paragraphs": [
        "Noise, notifications, poor sleep, acute illness, pain, hunger, anxiety, uncomfortable temperature, glare, connection failure, and interruptions can affect attention, speed, or persistence.",
        "Their effect is not identical for everyone, and one difficult session does not prove that a particular factor caused a specific score difference."
      ]
    },
    {
      "heading": "Why standardization helps",
      "paragraphs": [
        "Consistent instructions, timing, materials, environment, and scoring make comparisons with norms more defensible. Online testing gives users more control but also introduces more variation.",
        "Technology-based assessments should plan for device compatibility, accessibility, security, interruptions, and recovery from technical incidents."
      ]
    },
    {
      "heading": "What to do about a disrupted session",
      "paragraphs": [
        "Before starting, create stable conditions and use the supported device. If a serious interruption occurs, record it and follow the test’s restart or support policy instead of hiding the event.",
        "For a professional assessment, tell the examiner about relevant conditions. A retest may be appropriate in some cases, but practice effects and formal rules must be considered."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Can one bad night of sleep lower a test score?",
      "answer": "Fatigue can affect attention or speed, but the size of any effect varies and cannot be inferred precisely from one result."
    },
    {
      "question": "Should I retake after an interruption?",
      "answer": "Follow the assessment policy; immediate repetition can introduce practice effects and may not produce an independent estimate."
    }
  ],
  "related": ["does-sleep-affect-iq", "can-anxiety-lower-iq-scores", "can-you-retake-an-iq-test"],
  "sources": [
    {
      "label": "International Test Commission — technology-based assessment guidelines",
      "url": "https://www.intestcom.org/page/16"
    },
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    }
  ]
}
